// Strings of the vue components. Kept apart from the Rails locale files, so they have to
// be translated into both languages here as well.
export const messages = {
  en: {
    color_input: {
      hint: 'Select a color from the color picker or from the presets below.',
      picker: 'Color picker',
      presets: 'Preset colors',
    },
    copy_link: {
      copied: 'Copied',
      copy: 'Copy link',
      manual: 'Link to copy',
    },
    current_shifts: {
      absent: 'Not at the event',
      actions: {
        edit: 'Edit shift',
        more: 'More',
        move_into: 'Mark as on post',
        move_into_early: 'Mark as on post already, ahead of the shift',
        move_out: 'Mark as no longer on post',
        no_show: 'Mark as no-show',
        show: 'Showed up after all',
        swap: 'Swap shift',
      },
      clear_filters: 'Clear search and filter',
      columns: {
        next: 'Next',
        now: 'Now',
        positions: 'Position',
        volunteers: 'Volunteer',
      },
      division_shift: 'Division shift',
      empty: {
        positions: 'No position is staffed right now.',
        volunteers: 'No volunteer is on shift right now.',
      },
      failed: 'The shifts could not be loaded or changed. What is shown may be out of date.',
      hints: {
        ended: 'ended {time}',
        started: 'started {time}',
        starts: 'starts {time}',
      },
      issues: 'Shifts needing attention',
      loading: 'Loading shifts…',
      no_match: 'Nothing matches the search or filter.',
      not_on_post: 'Not on post yet',
      nothing_next: 'No further shift',
      nothing_now: 'No current shift',
      present: 'At the event',
      retry: 'Retry',
      search: {
        positions: 'Search positions, divisions or volunteers…',
        volunteers: 'Search volunteers, divisions or positions…',
      },
      show_idle: {
        positions: 'Also positions without a current shift',
        volunteers: 'Also volunteers without a current shift',
      },
      states: {
        absent: 'Volunteer not at the event',
        awaiting: 'Not on post yet',
        no_show: 'No-show',
        on_post: 'On post',
        overdue: 'Still on post after the end',
      },
      view: 'Show by',
      views: {
        positions: 'By position',
        volunteers: 'By volunteer',
      },
    },
    custom_attributes: {
      options: {
        add: 'Add option',
        move_down: 'Move down',
        move_up: 'Move up',
        remove: 'Remove',
      },
    },
    divisions: {
      attributes: {
        allrounders: 'Allrounders'
      },
      empty: 'No divisions available.',
      new_division: {
        failed: 'The division could not be created.',
        hint: 'Create a new division to assign positions and volunteers to it.',
        placeholder: 'Quick add division',
        submit: 'Create division',
      },
      new_volunteer: {
        failed: 'The volunteer could not be created.',
        placeholder: 'Quick add volunteer',
        submit: 'Create volunteer',
      },
    },
    event_volunteer_finder: {
      all_shifts: 'All your shifts',
      calendar: 'Calendar (.ics)',
      choose: "That's me",
      greeting: 'Hi {name}, your next shifts',
      hint: 'Type at least two letters of your name.',
      label: 'Your name',
      no_results: 'Nobody found by that name. Ask your supervisor if you are missing.',
      no_shifts: 'No more shifts planned for you yet.',
      not_me: 'Not you?',
      now: 'now',
      placeholder: 'Search for your name',
      title: 'Find your shifts',
      whole_division: 'together with {division}',
    },
    panel: {
      close: 'Close',
      failed: 'This could not be saved. Please try again.',
      label: 'Details',
      resize: 'Drag to make the panel wider or narrower, or use the arrow keys',
      saved: 'Saved. Select the next ones to go on.',
    },
    subscription: {
      subscribed: 'Subscribed',
      unsubscribed: 'Unsubscribed',
      unsupported: 'Subscriptions not supported by your browser',
    },
    volunteer_remember: {
      forget: 'Forget again in this browser',
      hint: 'Remember in this browser that you are this volunteer, to see your next shifts on the event page',
      remember: "That's me",
      remembered: "It's you",
    },
    volunteer_statistics: {
      average: 'Average per volunteer',
      clear_filters: 'Clear search and filter',
      columns: {
        no_shows: 'No-shows',
        periods: 'Working periods',
        total: 'Working time',
        volunteer: 'Volunteer',
      },
      compared: {
        division: 'Division',
        event: 'Event',
      },
      empty: 'No volunteer has been planned yet.',
      exceeding: 'Above the working time limit of {limit} h',
      failed: 'The statistics could not be loaded. What is shown may be out of date.',
      filters: {
        no_show: 'No-shows',
        over_limit: 'Above the working time limit',
        unplanned: 'Without shifts',
      },
      group_average: 'Average {hours} h',
      hours: '{hours} h',
      loading: 'Loading statistics…',
      long_rest: 'Long rest of {hours} h',
      markers: {
        division: 'Average of the division',
        event: 'Average of the event',
      },
      no_match: 'Nothing matches the search or filter.',
      no_periods: 'No shifts',
      no_show_summary: '{shifts} shift · {hours} h | {shifts} shifts · {hours} h',
      over_limit: 'Volunteers above the working time limit',
      retry: 'Retry',
      search: 'Search volunteers, divisions or comments…',
      sort: 'Sort',
      sorts: {
        dashboard: 'As on the dashboard',
        hours: 'Most hours first',
      },
      total: 'Planned working time',
    },
    timetable: {
      buttons: {
        scroll_to_now: 'Scroll to now',
      },
      grid: {
        label: 'Timetable. Zoom with ctrl and plus, minus or zero',
      },
      columns: {
        resize: 'Drag to make the column wider or narrower',
      },
      items: {
        resize_start: 'Drag to change when it starts',
        resize_end: 'Drag to change when it ends',
      },
      sort: {
        label: 'Order of the rows',
        default: {
          label: 'Sort by name',
          text: 'By name',
        },
        manual: {
          label: 'Sort in the order set by hand',
          text: 'Manual',
        },
        move: 'Drag to change the order, or use the arrow keys',
      },
      groups: {
        collapse: 'Collapse',
        expand: 'Expand',
        empty: 'Nothing in here yet',
      },
      list: {
        empty: 'No shifts yet',
      },
      incidents: {
        buttons: {
          edit_incidents: {
            label: 'Edit incidents',
            text: 'Incidents',
          },
        },
        public: 'Visible to everyone',
      },
      positions: {
        buttons: {
          edit_shifts: {
            label: 'Edit shifts',
            text: 'Shifts',
          },
          edit_requirements: {
            label: 'Edit requirements',
            text: 'Requirements'
          },
        },
        headers: {
          position: 'Name'
        }
      },
      shifts: {
        delete: "Delete",
        duplicate: "Duplicate",
        edit: "Edit",
        no_show: "No show",
        position_filled: "Position filled",
        position_unfilled: "Position unfilled",
        show: "Showed up",
        swap: "Swap",
        conflicts: {
          no_show: "No show",
          parallel_shift: "Parallel shift",
          no_attendance: "No attendance",
          not_present: "Not present",
          exceeding_working_time_limit: "Exceeding working time limit",
          no_break: "Break time too short",
        }
      },
      volunteers: {
        absent: "absent",
        present: "present",
        buttons: {
          add_attendance: {
            label: 'Add attendance',
            text: 'Attendance',
          },
          edit_shifts: {
            label: 'Edit shifts',
            text: 'Shifts',
          },
          remove_attendance: {
            label: 'Remove attendance',
            text: 'Attendance',
          },
        },
        headers: {
          volunteer: 'Name'
        }
      }
    }
  },
  de: {
    color_input: {
      hint: 'Wähle eine Farbe über den Farbwähler oder aus den Vorgaben darunter.',
      picker: 'Farbwähler',
      presets: 'Vorgegebene Farben',
    },
    copy_link: {
      copied: 'Kopiert',
      copy: 'Link kopieren',
      manual: 'Link zum Kopieren',
    },
    current_shifts: {
      absent: 'Nicht auf der Veranstaltung',
      actions: {
        edit: 'Schicht bearbeiten',
        more: 'Mehr',
        move_into: 'Als auf Position markieren',
        move_into_early: 'Schon vor Schichtbeginn als auf Position markieren',
        move_out: 'Nicht mehr als auf Position markieren',
        no_show: 'Als nicht erschienen markieren',
        show: 'Doch erschienen',
        swap: 'Schicht tauschen',
      },
      clear_filters: 'Suche und Filter zurücksetzen',
      columns: {
        next: 'Als Nächstes',
        now: 'Jetzt',
        positions: 'Position',
        volunteers: 'Helfer',
      },
      division_shift: 'Bereichsschicht',
      empty: {
        positions: 'Gerade ist keine Position besetzt.',
        volunteers: 'Gerade ist kein Helfer im Einsatz.',
      },
      failed: 'Die Schichten konnten nicht geladen oder geändert werden. Was angezeigt wird, ist eventuell nicht aktuell.',
      hints: {
        ended: 'endete {time}',
        started: 'begann {time}',
        starts: 'beginnt {time}',
      },
      issues: 'Schichten, die Aufmerksamkeit brauchen',
      loading: 'Schichten werden geladen…',
      no_match: 'Nichts passt zur Suche oder zum Filter.',
      not_on_post: 'Noch nicht auf Position',
      nothing_next: 'Keine weitere Schicht',
      nothing_now: 'Keine aktuelle Schicht',
      present: 'Auf der Veranstaltung',
      retry: 'Erneut versuchen',
      search: {
        positions: 'Positionen, Bereiche oder Helfer suchen…',
        volunteers: 'Helfer, Bereiche oder Positionen suchen…',
      },
      show_idle: {
        positions: 'Auch Positionen ohne aktuelle Schicht',
        volunteers: 'Auch Helfer ohne aktuelle Schicht',
      },
      states: {
        absent: 'Helfer nicht auf der Veranstaltung',
        awaiting: 'Noch nicht auf Position',
        no_show: 'Nicht erschienen',
        on_post: 'Auf Position',
        overdue: 'Nach Ende noch auf Position',
      },
      view: 'Anzeigen nach',
      views: {
        positions: 'Nach Position',
        volunteers: 'Nach Helfer',
      },
    },
    custom_attributes: {
      options: {
        add: 'Option hinzufügen',
        move_down: 'Nach unten',
        move_up: 'Nach oben',
        remove: 'Entfernen',
      },
    },
    divisions: {
      attributes: {
        allrounders: 'Springer'
      },
      empty: 'Keine Bereiche vorhanden.',
      new_division: {
        failed: 'Der Bereich konnte nicht erstellt werden.',
        hint: 'Erstelle einen neuen Bereich, um ihm Positionen und Helfer zuzuweisen.',
        placeholder: 'Bereich schnell hinzufügen',
        submit: 'Bereich erstellen',
      },
      new_volunteer: {
        failed: 'Der Helfer konnte nicht angelegt werden.',
        placeholder: 'Helfer schnell hinzufügen',
        submit: 'Helfer anlegen',
      },
    },
    event_volunteer_finder: {
      all_shifts: 'Alle deine Schichten',
      calendar: 'Kalender (.ics)',
      choose: 'Das bin ich',
      greeting: 'Hallo {name}, deine nächsten Schichten',
      hint: 'Gib mindestens zwei Buchstaben deines Namens ein.',
      label: 'Dein Name',
      no_results: 'Niemand mit diesem Namen gefunden. Frag deine Ansprechperson, falls du fehlst.',
      no_shifts: 'Für dich sind noch keine weiteren Schichten geplant.',
      not_me: 'Nicht du?',
      now: 'jetzt',
      placeholder: 'Nach deinem Namen suchen',
      title: 'Finde deine Schichten',
      whole_division: 'gemeinsam mit {division}',
    },
    panel: {
      close: 'Schließen',
      failed: 'Das konnte nicht gespeichert werden. Bitte versuche es erneut.',
      label: 'Details',
      resize: 'Ziehen, um die Seitenleiste breiter oder schmaler zu machen, oder Pfeiltasten verwenden',
      saved: 'Gespeichert. Wähle die nächsten aus, um weiterzumachen.',
    },
    subscription: {
      subscribed: 'Benachrichtigungen aktiv',
      unsubscribed: 'Benachrichtigungen deaktiviert',
      unsupported: 'Benachrichtigungen werden von diesem Browser nicht unterstützt',
    },
    volunteer_remember: {
      forget: 'In diesem Browser wieder vergessen',
      hint: 'In diesem Browser merken, dass du dieser Helfer bist, um deine nächsten Schichten auf der Seite der Veranstaltung zu sehen',
      remember: 'Das bin ich',
      remembered: 'Das bist du',
    },
    volunteer_statistics: {
      average: 'Durchschnitt pro Helfer',
      clear_filters: 'Suche und Filter zurücksetzen',
      columns: {
        no_shows: 'Nicht erschienen',
        periods: 'Arbeitsphasen',
        total: 'Arbeitszeit',
        volunteer: 'Helfer',
      },
      compared: {
        division: 'Bereich',
        event: 'Veranstaltung',
      },
      empty: 'Es wurde noch kein Helfer eingeplant.',
      exceeding: 'Über der Arbeitszeitbegrenzung von {limit} h',
      failed: 'Die Statistik konnte nicht geladen werden. Was zu sehen ist, ist möglicherweise veraltet.',
      filters: {
        no_show: 'Nicht erschienen',
        over_limit: 'Über der Arbeitszeitbegrenzung',
        unplanned: 'Ohne Schichten',
      },
      group_average: 'Durchschnitt {hours} h',
      hours: '{hours} h',
      loading: 'Statistik wird geladen…',
      long_rest: 'Lange Ruhepause von {hours} h',
      markers: {
        division: 'Durchschnitt des Bereichs',
        event: 'Durchschnitt der Veranstaltung',
      },
      no_match: 'Nichts passt zur Suche oder zum Filter.',
      no_periods: 'Keine Schichten',
      no_show_summary: '{shifts} Schicht · {hours} h | {shifts} Schichten · {hours} h',
      over_limit: 'Helfer über der Arbeitszeitbegrenzung',
      retry: 'Erneut versuchen',
      search: 'Helfer, Bereiche oder Kommentare suchen…',
      sort: 'Sortierung',
      sorts: {
        dashboard: 'Wie in der Übersicht',
        hours: 'Meiste Stunden zuerst',
      },
      total: 'Geplante Arbeitszeit',
    },
    timetable: {
      buttons: {
        scroll_to_now: 'Zu jetzt springen',
      },
      grid: {
        label: 'Zeitplan. Zoomen mit Strg und Plus, Minus oder Null',
      },
      columns: {
        resize: 'Ziehen, um die Spalte breiter oder schmaler zu machen',
      },
      items: {
        resize_start: 'Ziehen, um den Beginn zu ändern',
        resize_end: 'Ziehen, um das Ende zu ändern',
      },
      sort: {
        label: 'Reihenfolge der Zeilen',
        default: {
          label: 'Nach Name sortieren',
          text: 'Nach Name',
        },
        manual: {
          label: 'In der von Hand festgelegten Reihenfolge sortieren',
          text: 'Manuell',
        },
        move: 'Ziehen, um die Reihenfolge zu ändern, oder Pfeiltasten verwenden',
      },
      groups: {
        collapse: 'Zuklappen',
        expand: 'Aufklappen',
        empty: 'Hier ist noch nichts',
      },
      list: {
        empty: 'Noch keine Schichten',
      },
      incidents: {
        buttons: {
          edit_incidents: {
            label: 'Ereignisse bearbeiten',
            text: 'Ereignisse',
          },
        },
        public: 'Für alle sichtbar',
      },
      positions: {
        buttons: {
          edit_shifts: {
            label: 'Schichten editieren',
            text: 'Schichten',
          },
          edit_requirements: {
            label: 'Anforderungen editieren',
            text: 'Anforderungen',
          },
        },
        headers: {
          position: 'Name'
        }
      },
      shifts: {
        delete: "Löschen",
        duplicate: "Duplizieren",
        edit: "Editieren",
        no_show: "Nicht aufgetaucht",
        position_filled: "Position besetzt",
        position_unfilled: "Position nicht besetzt",
        show: "Aufgetaucht",
        swap: "Tauschen",
        conflicts: {
          no_show: "Nicht aufgetaucht",
          parallel_shift: "Parallele Schicht",
          no_attendance: "Keine Anwesenheit",
          not_present: "Nicht anwesend",
          exceeding_working_time_limit: "Arbeitszeitbegrenzung überschritten",
          no_break: "Pausenzeit zu kurz",
        }
      },
      volunteers: {
        absent: "abwesend",
        present: "anwesend",
        buttons: {
          add_attendance: {
            label: 'Anwesenheit hinzufügen',
            text: 'Anwesenheit',
          },
          edit_shifts: {
            label: 'Schichten editieren',
            text: 'Schichten',
          },
          remove_attendance: {
            label: 'Anwesenheit entfernen',
            text: 'Anwesenheit',
          },
        },
        headers: {
          volunteer: 'Name'
        }
      }
    }
  }
}
